import { setContainer } from '@patsnap/tahiti-core/ioc/inject';
import { Container, inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { fluentProvide, provide } from 'inversify-binding-decorators';
import getDecorators from 'inversify-inject-decorators';
const container = new Container({
    defaultScope: 'Singleton',
    autoBindInjectable: true,
});
setContainer(container);
const { lazyInject } = getDecorators(container);
// 显式单例
function provideSingleton(identifier) {
    return fluentProvide(identifier).inSingletonScope().done();
}
// 显式非单例
function provideTransient(identifier) {
    return fluentProvide(identifier).inTransientScope().done();
}
// 获取服务
function injectService(serviceIdentifier) {
    if (!serviceIdentifier || !container)
        return null;
    return container.get(serviceIdentifier);
}
function unbindService(serviceIdentifier) {
    container.unbind(serviceIdentifier);
}
export { container, injectService, inject, injectable, lazyInject, provide, provideSingleton, provideTransient, unbindService, };
